// extracted by mini-css-extract-plugin
export default {"Embed_container":"PowerBI_Embed_container__gycpP","content":"PowerBI_content__NbhIR"};